module.exports = __webpack_public_path__ + "img/m-banner-zlslctgf-ko-KR.c46655b9.png";